import {TFactors, TForecastCommentsCore} from '../../model/types';
import {MAX_MESSAGE_LENGTH} from './edit.modal.constants';

/**
 * Создает конфигурацию полей формы на основе факторов из бэкенда
 *
 * @param factors - Массив факторов из данных бэкенда
 * @param isNewRequest - Флаг, что запрос в статусе "Новый" (status = false)
 *
 * @returns Массив конфигураций полей для каждого фактора
 */
export const createForecastCommentsFormFields = (factors: TFactors[], isNewRequest: boolean) =>
    factors.map((factor, index) => {
        const fields = [
            {
                key: `forecastValueFts-${index}`,
                label: 'Прогноз НО',
                name: ['factors', index, 'forecastValueFts'],
                initialValue: factor.forecastValueFts,
                disabled: true,
                component: 'input',
            },
            ...(factor.forecastCommentFts
                ? [
                      {
                          key: `forecastCommentFts-${index}`,
                          label: 'Комментарий НО',
                          name: ['factors', index, 'forecastCommentFts'],
                          initialValue: factor.forecastCommentFts,
                          disabled: true,
                          component: 'textarea',
                      },
                  ]
                : []),
            {
                key: `forecastValueOrg-${index}`,
                label: 'Прогноз НП',
                name: ['factors', index, 'forecastValueOrg'],
                initialValue: factor.forecastValueOrg,
                disabled: !isNewRequest,
                component: 'input',
                placeholder: 'Введите значение',
                rules: isNewRequest ? [{required: true, message: 'Поле обязательно для заполнения'}] : [],
            },
            {
                key: `forecastCommentOrg-${index}`,
                label: 'Комментарий НП',
                name: ['factors', index, 'forecastCommentOrg'],
                initialValue: factor.forecastCommentOrg,
                disabled: !isNewRequest,
                component: 'textarea',
                placeholder: 'Введите значение',
                rules: [
                    ...(isNewRequest ? [{required: true, message: 'Поле обязательно для заполнения'}] : []),
                    {max: MAX_MESSAGE_LENGTH, message: `Максимальное число символов ${MAX_MESSAGE_LENGTH}`},
                ],
            },
        ];

        return {sectionTitle: factor.factorName, fields};
    });

/**
 * Преобразует данные формы и исходные данные прогноза в формат для отправки на бэкенд
 *
 * @param {TForecastCommentsCore} forecastComments - Исходные данные прогноза из store
 * @param {Pick<TForecastCommentsCore, 'factors'>} formFactors - Значения из формы
 *
 * @returns {TForecastCommentsCore} Данные в формате для отправки на бэкенд
 *
 */
export const createForecastSubmitData = (
    forecastComments: TForecastCommentsCore,
    formFactors: Pick<TForecastCommentsCore, 'factors'>
): TForecastCommentsCore => {
    const {id, taxPeriod, reportingYear, factors} = forecastComments;

    return {
        id,
        taxPeriod,
        reportingYear,
        factors: formFactors.factors.map((factor, index) => ({
            id: factors[index].id,
            factorName: factors[index].factorName,
            forecastValueFts: factors[index].forecastValueFts,
            forecastCommentFts: factors[index].forecastCommentFts,
            forecastValueOrg: factor.forecastValueOrg,
            forecastCommentOrg: factor.forecastCommentOrg,
        })),
    };
};
